import React from 'react'

export default function Times() {
  return (
    <svg className='w-2.5 sm:w-auto'
    xmlns="http://www.w3.org/2000/svg"
    width="15"
    height="17"
    fill="none"
    viewBox="0 0 16 17"
  >
    <g clipPath="url(#clip0_11_1719)">
      <rect
        width="15.812"
        height="15.812"
        x="0.004"
        y="0.503"
        fill="#F5F8FF"
        rx="7.906"
      ></rect>
      <path
        fill="#011B64"
        d="M7.91 1.48C4.097 1.48.98 4.598.98 8.409c0 3.81 3.118 6.929 6.93 6.929 3.81 0 6.928-3.118 6.928-6.93 0-3.81-3.118-6.928-6.929-6.928zm2.755 8.46a.433.433 0 010 .612l-.612.613a.433.433 0 01-.612 0L7.909 9.633l-1.53 1.532a.433.433 0 01-.613 0l-.613-.613a.433.433 0 010-.612L6.685 8.41 5.153 6.878a.433.433 0 010-.613l.613-.612a.433.433 0 01.612 0L7.91 7.184l1.532-1.531a.433.433 0 01.612 0l.612.612a.433.433 0 010 .613l-1.531 1.53 1.531 1.532z"
      ></path>
    </g>
    <defs>
      <clipPath id="clip0_11_1719">
        <rect
          width="15.812"
          height="15.812"
          x="0.004"
          y="0.503"
          fill="#fff"
          rx="7.906"
        ></rect>
      </clipPath>
    </defs>
  </svg>
  )
}
